import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { NbfcDetailStatus } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const driveUserNBFCStatusOptions = [
	{ value: NbfcDetailStatus.DISBURSAL_DONE, label: 'Disbursal Done' },
	{ value: NbfcDetailStatus.DISBURSAL_PENDING, label: 'Disbursal Pending' },
	{ value: NbfcDetailStatus.FORCLOSED, label: 'Foreclosed' },
];

const DriveUserNBFCStatusFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const nbfcStatus = JSON.parse(searchParams.get('nbfcStatus') || '[]');

	const options = driveUserNBFCStatusOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!nbfcStatus?.length}
					placeholder={'NBFC Status'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: nbfcStatus?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (nbfcStatus?.includes(option?.value?.toString())) {
											searchParams.set(
												'nbfcStatus',
												JSON.stringify(nbfcStatus?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('nbfcStatus', JSON.stringify([...nbfcStatus, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{nbfcStatus?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">NBFC Status</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="NBFC Status"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => nbfcStatus?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('nbfcStatus', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserNBFCStatusFilterInput;
